import { PrivyProvider } from "@privy-io/react-auth";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { baseSepolia, polygon } from "viem/chains";
import config, { isDevelopment } from "@/config";
import { role } from "@/features/auth/types";
import { useOrigin } from "@/features/flow/hooks/use-origin";
import { FromURL } from "@/features/flow/types";
import { usePartnerInfo } from "@/features/partner/hooks/use-partner-information";
import { useUser } from "@/features/user/hooks/use-user";
import { identityPartners } from "@/features/user/types";
import { isSystemThemeDark } from "@/features/utils/theme";
import { useAppSelector } from "@/redux/hooks";
import { getUserRoles } from "@/redux/slices/userSlice";

export const PrivyPrivateRouteLayout = () => {
  const origin = useOrigin();
  const userRoles = useAppSelector(getUserRoles);
  const isAdmin = userRoles.includes(role.ADMIN);
  const { t } = useTranslation(["wallet"]);
  const { partnerUuidQuery } = usePartnerInfo();
  const { useUserProfile } = useUser();
  const { data: user } = useUserProfile();
  const { data: dataPartner } = partnerUuidQuery(
    (sessionStorage.getItem("origin") as string) ?? null
  );
  const identityPartner = (() =>
    user?.identityPartners?.find(
      (partner: identityPartners) => partner.uuid === dataPartner?.data.partner_uuid
    ))();
  const allowPrivy = (() =>
    config.USE_PRIVY &&
    (origin === FromURL.None ||
      (origin === FromURL.Partner &&
        identityPartner?.mode === "TOKEN" &&
        identityPartner?.token?.address)))();

  return allowPrivy && !isAdmin ? (
    <PrivyProvider
      appId={config.PRIVY_APP_ID}
      clientId={config.PRIVY_CLIENT_ID}
      config={{
        supportedChains: [isDevelopment ? baseSepolia : polygon],
        defaultChain: isDevelopment ? baseSepolia : polygon,
        appearance: {
          showWalletLoginFirst: true,
          theme: isSystemThemeDark() ? "dark" : "light",
          loginMessage: `${t("kypay.modal_add_wallet.privy.login_label")}`,
          logo: "https://www.olky.eu/media/cache/webp_filtered/images/services/logo-olky-content.png?1.0.5",
          accentColor: `#${"00afeb"}`
        },

        loginMethods: ["email", "wallet"],
        embeddedWallets: {
          ethereum: {
            createOnLogin: "users-without-wallets"
          }
        }
      }}
    >
      <Outlet />
    </PrivyProvider>
  ) : (
    <Outlet />
  );
};
